import { type ReactNode } from 'react';

interface HeaderProps {
  title: string;
  subtitle?: string;
  rightAction?: ReactNode;
  leftAction?: ReactNode;
}

export function Header({ title, subtitle, rightAction, leftAction }: HeaderProps) {
  return (
    <header className="animate-fade-up" style={{
      padding: '24px 20px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid var(--journal-line)',
      background: 'linear-gradient(180deg, var(--journal-bg-warm) 0%, var(--journal-bg) 100%)',
    }}>
      <div style={{ width: 44, display: 'flex', justifyContent: 'flex-start' }}>
        {leftAction}
      </div>
      <div style={{ textAlign: 'center', flex: 1 }}>
        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.75rem',
          fontWeight: 800,
          letterSpacing: '-0.02em',
          color: 'var(--journal-ink)',
          margin: 0,
          lineHeight: 1.2,
        }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.85rem',
            color: 'var(--journal-ink-light)',
            margin: '4px 0 0',
            fontWeight: 400,
          }}>
            {subtitle}
          </p>
        )}
      </div>
      <div style={{ width: 44, display: 'flex', justifyContent: 'flex-end' }}>
        {rightAction}
      </div>
    </header>
  );
}
